import { NodeType } from '@/features/connect-dots/types/cytoscape';
import { useSelectedFilterItemsImpl } from '../hooks/useSelectedFilterItemsImpl';

export type SelectedFilterItemsContextType = ReturnType<
  typeof useSelectedFilterItemsImpl
>;

export const FilterItemMode = { AND: 'and', OR: 'or', NOT: 'not' } as const;
export type FilterItemInfo = {
  name: string;
  nodeType: NodeType;
  label: string;
  mode: (typeof FilterItemMode)[keyof typeof FilterItemMode];
  hasSelected?: boolean; // 事前に選択されているかどうか
};
